import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full bg-foreground-900 text-foreground-200">
      {/* Top separator */}
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 pt-10 md:pt-14">
        <div className="border-t border-foreground-700/50" />
      </div>

      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-8">
          {/* Logo & Social - 1/4 */}
          <div className="lg:w-1/4 flex flex-col items-start gap-5">
            <div className="flex flex-col items-center">
              <img
                              src="/images/logo.png"
                alt="Southern Transit LLC"
                width={97}
                height={100}
                className="w-[97px] h-auto"
              />
            </div>
          </div>

          {/* Contact - 1/3 */}
          <div className="lg:w-1/3">
            <h3 className="font-heading text-xl font-semibold text-background-50 mb-4">
              <Link to="/contact-us" className="hover:text-primary-400 transition-colors">
                Contact Us
              </Link>
            </h3>
            <div className="space-y-1.5 text-sm leading-relaxed">
              <p>Southern Transit LLC</p>
              <p>(712) 206-1196</p>
              <p>
                <a
                  href="mailto:lynn@southerntransit.us"
                  className="text-foreground-300 hover:text-primary-400 transition-colors"
                >
                  lynn@southerntransit.us
                </a>
              </p>
              <p>9245 County Road 43.6, Trinidad, CO 81082</p>
            </div>
          </div>

          {/* Newsletter Signup - 2/5, styled like original ConvertKit form */}
          <div className="lg:w-[40%] lg:ml-auto">
            <div className="bg-background-50 rounded-lg p-6">
              <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-1">
                Sign Up For Updates
              </h3>
              <p className="text-sm text-foreground-500 mb-4">
                ​
              </p>
              <form
                data-readdy-form
                id="d9p2hdaftmtnfcfh0gb0"
                action=""
                method="POST"
                onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  const honeypot = formData.get("company_alt");
                  if (honeypot && String(honeypot).trim() !== "") {
                    return;
                  }
                  if (honeypot) formData.delete("company_alt");
                  fetch(form.action, {
                    method: "POST",
                    body: formData,
                  })
                    .then(async (res) => {
                      const text = await res.text();
                      let parsed;
                      try { parsed = JSON.parse(text); } catch { /* noop */ }
                      if (res.ok && parsed?.code === "OK") {
                        alert("Thank you for subscribing!");
                        form.reset();
                      } else {
                        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text || "Submission failed. Please try again.";
                        alert(msg);
                      }
                    })
                    .catch(() => alert("Something went wrong. Please try again."));
                }}
              >
                {/* Honeypot */}
                <div className="honeypot-field">
                  <input
                    type="text"
                    name="company_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                  />
                </div>
                <div className="flex flex-col sm:flex-row gap-3">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    required
                    className="flex-1 px-4 py-3 bg-background-100 border border-background-200/70 rounded-md text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent"
                  />
                  <button
                    type="submit"
                    className="px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
                  >
                    Subscribe
                  </button>
                </div>
                <p className="mt-3 text-xs text-foreground-500">
                  We won&apos;t send you spam. Unsubscribe at any time.
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-foreground-800">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-5">
          <p className="text-xs text-foreground-500 text-center">
            &copy; {new Date().getFullYear()} All Rights Reserved by Southern Transit LLC &bull;{" "}
            
              
            
          </p>
        </div>
      </div>
    </footer>
  );
}